// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"9ff71cfb2e1d16f16a03","339":"6663884210bc4613e40a"}[chunkId] + ".js";
};